import {BreadCrumb} from "../types/hygiena-types";

/**
 * Builds out an array of breadcrumbs
 * @param taxonomy_term
 *   The taxonomy term.
 * @param breadcrumbs
 *   Should be passed an empty array at first, which will be populated with bread crumbs.
 */
export function buildBreadCrumbs(taxonomy_term, breadcrumbs) {
  if (taxonomy_term?.path?.alias) {
    breadcrumbs.unshift({
      id: taxonomy_term.id,
      name: taxonomy_term.name,
      url: taxonomy_term.path.alias,
    });
    if (taxonomy_term?.parent) {
      buildBreadCrumbs(taxonomy_term.parent[0], breadcrumbs);
    }
  }
}
